<template>
  <div :class="sidebar_classes">
    <div class="sidebar-worksheet__content">
      <a
        href="javascript:void(0)"
        :class="arrow_clasees"
        @click="is_sidebar_open = !is_sidebar_open"
      ></a>
      <vue-scroll :class="sidebar_wrap_clasees">
        <draggable
          class="sidebar-worksheet__menu"
          :list="menu_items"
          :group="{ name: 'controls', pull: 'clone', put: false }"
          :sort="false"
        >
          <menu-item
            v-for="item in menu_items"
            :key="item.type"
            :type="item.type"
            class="sidebar-menu__item"
          />
        </draggable>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
  import Draggable from '@app/plugins/vuedraggable';
  import MenuItem from '@pbx/components/worksheets/action-types/menu-item';
  import { LIST_ACTION_TYPES } from '@pbx/helpers/worksheets/action-types';

  export default {
    components: {
      Draggable,
      MenuItem
    },

    data() {
      return {
        is_sidebar_open: true,
        menu_items: LIST_ACTION_TYPES.map((i) => ({
          type: i
        }))
      };
    },

    computed: {
      arrow_clasees: function () {
        return this.$config.show_low_balance_notification
          ? 'sidebar-worksheet__button-toggle sidebar-worksheet__button-toggle--with-banner'
          : 'sidebar-worksheet__button-toggle';
      },
      sidebar_wrap_clasees: function () {
        return this.$config.show_low_balance_notification
          ? 'sidebar-worksheet__scroll sidebar-worksheet__scroll--with-banner'
          : 'sidebar-worksheet__scroll';
      },
      sidebar_classes: function () {
        return {
          sidebar: true,
          'sidebar-worksheet': true,
          'sidebar-worksheet--open': this.is_sidebar_open
        };
      }
    }
  };
</script>

<style lang="scss">
  .sidebar-worksheet {
    position: fixed;
    left: 0;
    top: 70px;
    height: calc(100vh - 70px);
    padding-bottom: 20px;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;
    transform: translateX(-280px);

    &--open {
      transform: translateX(0);

      .sidebar-worksheet__button-toggle {
        background: url('/img/icons/pbx/arrow-left.svg') no-repeat center #ffffff;
      }
    }

    &__scroll--with-banner {
      margin-top: 70px;
    }

    &__content {
      display: inline-block;
      position: relative;
      width: 100%;
      height: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    &__button-toggle {
      width: 44px;
      height: 52px;
      z-index: 3;
      display: inline-block;
      right: -45px;
      top: -10px;
      position: absolute;
      border: 1px solid $grey-dark;
      border-left: none;
      background: url('/img/icons/pbx/arrow-right.svg') no-repeat center #ffffff;
    }

    &__button-toggle--with-banner {
      top: 40px;
    }
  }

  .sidebar-menu__item {
    margin-bottom: 20px;
    cursor: pointer;

    &:first-child {
      margin-top: 10px;
    }
  }
</style>
